import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../environment";
 
const BASE_URL = `${API_BASE_PATH}/todo`;
 
const getAuthHeaders = () => {
  const token = localStorage.getItem("authToken") || "";
  return {
    Authorization: token,
    Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded", // Required by backend
  };
};
 
const showAxiosError = (error: any, fallback: string) => {
  const detail = error?.response?.data?.detail || error?.message || fallback;
  toast.error(detail);
};
 
// Interfaces
export interface Todo {
  todo_id: string;
  title: string;
  description: string;
  priority: string;
  status: string;
  due_date: string;
  user: {
    id: string;
    name: string;
  };
  client: {
    client_id: string;
  };
  created_at: string;
  updated_at: string;
  remarks: string;
  assigned_by_user: {
    id: string;
    name: string;
  };
}
 
// ✅ Create Todo
export const createTodo = async (form: {
  title: string;
  description: string;
  priority: string;
  status_: string;
  due_date: string;
  user_id: string;
}): Promise<Todo> => {
  try {
    const formData = new URLSearchParams({
      ...form,
    });
 
    const response = await axios.post(`${BASE_URL}/create`, formData, {
      headers: getAuthHeaders(),
    });
 
    //toast.success("ToDo created successfully");
    return response.data;
  } catch (error) {
    showAxiosError(error, "Failed to create ToDo");
    throw error;
  }
};
 
// ✅ Get Todo by ID
export const fetchTodoById = async (todo_id: string): Promise<Todo> => {
  try {
    const response = await axios.get(`${BASE_URL}/${todo_id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    showAxiosError(error, "Failed to fetch ToDo");
    throw error;
  }
};
 
// ✅ Update Todo
export const updateTodo = async (
  todo_id: string,
  form: {
    title: string;
    description: string;
    priority: string;
    status_: string;
    due_date: string;
    user_id :string;
  }
) => {
  const formData = new URLSearchParams(form);
 
  const res = await axios.put(`${BASE_URL}/${todo_id}/update`, formData, {
    headers: getAuthHeaders(),
  });
 
  return res.data;
};
 
 
// ✅ Delete Todo
export const deleteTodo = async (todo_id: string): Promise<void> => {
  try {
    await axios.delete(`${BASE_URL}/${todo_id}/delete`, {
      headers: getAuthHeaders(),
    });
    //toast.success("ToDo deleted successfully");
  } catch (error) {
    showAxiosError(error, "Failed to delete ToDo");
    throw error;
  }
};
 
 
//fetch todo by userid
// ✅ Get Todos by User ID
export const fetchTodosByUserId = async (user_id: string): Promise<Todo[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/user/${user_id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error: any) {
    const status = error?.response?.status;

    // Suppress toast only for 500 error if considered safe
    if (status !== 500) {
      showAxiosError(error, "Failed to fetch ToDos for user");
    } else {
      console.warn("Server returned 500. Assuming no todos or internal issue.");
    }

    // Optionally return empty array to avoid breaking UI
    if (status === 500) {
      return [];
    }

    throw error;
  }
};
export const fetchTodosByClientId = async (client_id: string): Promise<Todo[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/client/${client_id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error: any) {
    const status = error?.response?.status;

    // Suppress toast only for 500 error if considered safe
    if (status !== 500) {
      showAxiosError(error, "Failed to fetch ToDos for client");
    } else {
      console.warn("Server returned 500. Assuming no todos or internal issue.");
    }

    // Optionally return empty array to avoid breaking UI
    if (status === 500) {
      return [];
    }

    throw error;
  }
};


 
const BASE_URL1 = `${API_BASE_PATH}/users`;
 
// ✅ Interface
export interface User {
  id: string;
  name: string;
  email: string;
  phone_no: string;
  role: string;
  status: boolean;
  is_deleted: boolean;
  organisation_id: string;
  client_id: string;
}
 
// ✅ Get Users by Client ID
export const fetchUsersByClientId = async (
  client_id: string
): Promise<User[]> => {
  try {
    const res = await axios.get(`${BASE_URL1}/by-client/${client_id}`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (error) {
    showAxiosError(error, "Failed to fetch users");
    throw error;
  }
};
 
const BASE_URL2 = `${API_BASE_PATH}/clients`;
 
// ✅ Interface
export interface Client {
  client_name: string;
  client_email: string;
  plan_id: string;
  website: string;
  password: string;
  address: string;
  account_url: string;
  is_active: boolean;
  is_deleted: boolean;
  client_id: string;
  created_at: string;
  plan: {
    plan_id: string;
    plan_name: string;
    plan_type: string;
    plan_price: string;
  };
}
 
// ✅ Get All Clients
export const fetchAllClients = async (): Promise<Client[]> => {
  try {
    const res = await axios.get(`${BASE_URL2}/`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (error) {
    showAxiosError(error, "Failed to fetch clients");
    throw error;
  }
};
